export default {
  API_ENDPOINT: "https://sheltered-mesa-92095.herokuapp.com/api",
  TOKEN_KEY: "fitness-pizza-auth-token",
};
